import { Component, EventEmitter, Input, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { MatSelectModule } from '@angular/material/select';
import { MatFormFieldModule } from '@angular/material/form-field';
import { UserDataService } from 'src/app/services/userData.service';
import { SignalRService } from '../../services/communications/signalr.service';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { UserRole } from '../../constants/constants';
import { AudioConnectorService } from '../../services/audioConnector.service';
import { Subscription } from 'rxjs';
import { MatDialog } from '@angular/material/dialog';
import { ApiService } from '../../services/communications/api.service';
import { PipesModule } from '../../pipes/pipes.module';
import { MatButtonModule } from '@angular/material/button';
import { CommentModalComponent } from './comment-modal/comment-modal.component';
import { ModalComponent } from '../modal/modal.component';
import { MatTooltipModule } from '@angular/material/tooltip';


@Component({
  selector: 'directCall-comments',
  imports: [CommonModule, MatSelectModule, MatFormFieldModule, TranslateModule, MatSlideToggleModule, PipesModule, MatButtonModule, MatTooltipModule],
  templateUrl: './comments.component.html',
  styleUrls: ['./comments.component.scss', '../../styles/components/panel.scss']
})

export class CommentsComponent {

  currentUserId;

  @Input() stickyMode: boolean = false;
  @Input() withMenu: boolean = false;
  @Output() close = new EventEmitter<string>();

  onAddCommentAsset!: Subscription;
  onDeleteCommentAsset!: Subscription;
  UserRole = UserRole;
   
  isExpert: boolean;

  constructor(public userDataService: UserDataService, private signalRService: SignalRService, public audioConnectorService: AudioConnectorService, public dialog: MatDialog, private apiService: ApiService, private translate: TranslateService) {
    this.currentUserId = userDataService.Id!;
    this.isExpert = userDataService.isExpert();

    this.signalREventsHook();
  }

  ngOnInit(): void {
    console.log('comments', this.userDataService.assetInfo.comments);
  }

  ngOnDestroy() {
    this.onAddCommentAsset.unsubscribe();
    this.onDeleteCommentAsset.unsubscribe();
  }

  closeChat() {
    this.close.emit();
  }

  signalREventsHook() {
    console.log("** signalREventsHook comment");

    this.onAddCommentAsset = this.signalRService.onAddCommentAsset.subscribe(assetComment => {
      console.log("add new comment", assetComment);
      this.userDataService.assetInfo.comments.unshift(assetComment);
    });

    this.onDeleteCommentAsset = this.signalRService.onDeleteCommentAsset.subscribe(commentId => {
      console.log("delete comment", commentId);
      this.userDataService.assetInfo.comments = this.userDataService.assetInfo.comments.filter(c => c.id != commentId);
    });

  }

  createComment(responsive: boolean) {
    const closeCreateCommentDialog = this.dialog.open(CommentModalComponent, {
      width: responsive ? '75%' : '50%',
      autoFocus: true
    });

    closeCreateCommentDialog.afterClosed().subscribe((comment: string) => {
      console.log("add comment", comment);
      if (comment != undefined && comment != '') {
        this.addNew(comment);
      }
    });

  }

  addNew(comment: string) {
    this.apiService.addNewComment(this.userDataService.assetInfo.id, this.userDataService.Id!, comment).subscribe({
      next: (data: any) => {
        if (data == null) {
          console.log("No comment asset data ", data);
          return;
        }
        console.log("Added comment asset", data);

      },
      error: (error) => { console.error(error); }
    });
  }

  delete(commentId: number) {

    const deleteCommentDialog = this.dialog.open(ModalComponent, {
      autoFocus: true,
      data: {
        title: 'COMMENTS.DELETE',
        message: 'COMMENTS.MODAL_DELETE_COMMENT_CONTENT',
        addButtons: true
      }
    });

    deleteCommentDialog.afterClosed().subscribe((result: boolean) => {
      if (result == true) {
        this.apiService.deleteComment(this.userDataService.assetInfo.id, this.userDataService.Id!, commentId).subscribe({
          next: (data: any) => {
            if (data == null) {
              console.log("No comment ", data);
              return;
            }
          },
          error: (error) => { console.error(error); }
        });
      }
      
    });

   
  }

}
